import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import capitalize from 'lodash/capitalize';
import { MultiRadio, CheckboxList } from 'shared/components';
import * as options from './options';

const translate = (listOfOptions, t) => {
  listOfOptions.forEach((option) => {
    option.label = t(option.label);
  });
  return listOfOptions;
};

const setRespOtions = (user, optionsList, t) => {
  optionsList.forEach((opt) => {
    opt.checked = user[opt.key];
    opt.label = t(opt.label);
  });
  return optionsList;
};

class DemographicQuestions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.user,
      education: '',
      educationOptions: translate(options.educationOptions, props.t),
      responsibilitiesOptions: props.user
        ? setRespOtions(props.user, options.responsibilitiesOptions, props.t)
        : [],
    };

    this.onEducationChange = this.onEducationChange.bind(this);
    this.onResponsibilityChange = this.onResponsibilityChange.bind(this);
    this.onOtherRespChange = this.onOtherRespChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { user } = this.props;

    this.setState({
      education: user.educationLevel ? capitalize(user.educationLevel.level) : '',
      otherResponsibility: user && user.otherJobFlag,
    });
  }

  onEducationChange(e) {
    const { value } = e.target;
    this.setState({
      education: value,
    });
  }

  onResponsibilityChange(e) {
    const { responsibilitiesOptions } = this.state;
    const { name, checked } = e.target;

    if (name === 'otherJobFlag') {
      this.setState((prevState) => ({
        otherResponsibility: !prevState.otherResponsibility,
      }));
    }
    responsibilitiesOptions.forEach((option) => {
      if (option.key === name) {
        option.checked = checked;
      }
    });

    this.setState({
      responsibilitiesOptions,
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { user } = this.state;
    const { otherResponsibility } = this.state;

    this.state.responsibilitiesOptions.forEach((option) => {
      user[option.key] = option.checked;
    });
    user.otherJobFlag = otherResponsibility;
    user.otherJobDesc = otherResponsibility ? user.otherJobDesc : '';

    if (user.otherJobFlag && !user.otherJobDesc) {
      this.setState({
        error: 'profile.background.errorResponsibility',
      });
      return;
    }
    const userNew = Object.assign({}, user, {
      educationLevel: this.state.education ? { level: this.state.education } : null,
    });
    this.props.onSubmit(userNew, 1);
  }

  onOtherRespChange(e) {
    const { value } = e.target;
    this.setState((prevState) => ({
      user: {
        ...prevState.user,
        otherJobDesc: value,
      },
      error: '',
    }));
  }

  render() {
    return (
      <section className="demographic-questions">
        <form onSubmit={this.onSubmit} className="list-group list-group-flush">
          <div>
            <div className="list-group-item">
              <h6>
                {this.props.t('profile.background.educationQuestion')} (
                {this.props.t('common.labels.optional')})
              </h6>
              <MultiRadio
                radioList={this.state.educationOptions}
                checkedValue={this.state.education}
                onChange={this.onEducationChange}
              />
            </div>
            <div className="list-group-item">
              <CheckboxList
                checkboxes={this.state.responsibilitiesOptions}
                onChange={this.onResponsibilityChange}
                title={`${this.props.t('profile.background.jobQuestion')} (${this.props.t(
                  'common.labels.optional'
                )})`}
              />
              <div className="input-container form-group">
                <div className="input-group">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="otherJobFlag"
                    key="otherJobFlag"
                    id="inputJob"
                    onChange={this.onResponsibilityChange}
                    checked={this.state.otherResponsibility}
                  />
                  <label className="w-100 form-check-label" htmlFor="inputJob">
                    <input
                      className={`${this.state.error ? 'error' : ''} w-100`}
                      type="text"
                      placeholder={this.props.t('common.labels.other')}
                      onChange={this.onOtherRespChange}
                      disabled={!this.state.otherResponsibility}
                      value={this.state.otherResponsibility ? this.state.user.otherJobDesc : ''}
                    />
                  </label>
                  {this.state.error && (
                    <span className="text-error text-small">{this.props.t(this.state.error)}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="buttons-container">
            <button type="button" onClick={() => this.props.onCancel(1)} className="btn w-50">
              {this.props.t('common.labels.back')}
            </button>
            <button type="submit" className="btn btn-primary w-50 ">
              {this.props.t('common.labels.continue')}
            </button>
          </div>
        </form>
      </section>
    );
  }
}

DemographicQuestions.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  user: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(DemographicQuestions);
